import { Fragment } from "react";
import { VStack } from "goi_common";

import ParlorItem from "./ParlorItem";
import RegionLeadSupportCard from "./RegionLeadSupportCard";

/** 목록 중간 리드 카드 삽입 위치 (5번째 아이템 뒤) */
const LEAD_CARD_INSERT_INDEX = 4;
/** 중간 카드는 목록이 충분히 길어 끝 카드와 겹쳐 보이지 않을 때만 노출 */
const LEAD_CARD_MIN_PARLORS = 8;

function ParlorListTabPanel({
  name,
  parlors,
  serviceName,
  expectedParlorPrice,
  withLeadCards = false,
}: {
  parlors: any;
  serviceName?: string;
  name: string;
  expectedParlorPrice: number;
  sido?: string;
  sigungu?: string;
  /** 목록 중간·끝 선택 서포트 리드 카드 노출 여부 (SEO hidden 목록에선 사용 X) */
  withLeadCards?: boolean;
}) {
  const showMidLeadCard = withLeadCards && parlors.length >= LEAD_CARD_MIN_PARLORS;

  return (
    <VStack gap={16} padding="10px 18px 80px" className="body_14_m" width="100%">
      {parlors?.map((p: any, i: number) => (
        <Fragment key={p.companyname + "_" + p.id}>
          <ParlorItem
            id={p.id}
            sido={p.sido}
            src={p.images.length > 0 ? p.images[0].url : undefined}
            name={p.companyname}
            address={p.address}
            serviceName={serviceName}
            price={
              serviceName
                ? p.expected_charge_sum[
                    serviceName === "무빈소장례"
                      ? "무빈소"
                      : (serviceName as "무빈소" | "가족장" | "일반장")
                  ]
                : p.binso_average_charge
            }
            type={p.type}
            description={p.percentage ? `평균보다 ${p.percentage}% 저렴해요` : ""}
            binsosCount={p.binsos?.length}
            hasParkinglot={p.amenities?.has_parkinglot}
            hasMealroom={p.amenities?.has_mealroom}
          />
          {showMidLeadCard && i === LEAD_CARD_INSERT_INDEX && (
            <RegionLeadSupportCard
              title="임종이 가까워지고 있나요?"
              description="지금 꼭 필요한 것부터, 24시간 임종 상담으로 바로 도와드려요."
              buttonText="24시간 임종 상담"
              trigger="list_mid_card-opn_mdl"
              action={{ type: "urgent" }}
            />
          )}
        </Fragment>
      ))}
      {parlors.length === 0 && "이 지역에 주소를 둔 장례식장이 검색되지 않았습니다."}
    </VStack>
  );
}
export default ParlorListTabPanel;
